import { Col, Row, Table } from "antd";
import React from "react";
import { ReportTypeEnum, ScenarioFrontierFileType } from "../../../../../../constants/constants";
import { FileParsedModel } from "../../../../../../models/scenario-frontier.model";
import { DATA_TABLE_UTIL } from "../../../../../../utils/data-table.utils";
import "./index.scss";

interface Props {
    year: number,
    data: FileParsedModel[];
    includeConcentrationStressTest?: boolean;
}

const FrontierTableOutput = (props: Props) => {

    const getColumns = (fileData: any[], columns: any): any[] => {
        return DATA_TABLE_UTIL.getColumnsTableData(fileData, ReportTypeEnum.CreditandConcentrationStressTesting, columns)
    }

    return (
        <div className="frontier-output-table-wrapper">
            <Row>
                <Col span={24}>
                    {
                        props.data.map((item) =>
                            !props.includeConcentrationStressTest && item.file_type === ScenarioFrontierFileType.SFSB_RESULT_6 ? null :
                                <Table
                                    key={item.file_type}
                                    id={item.file_type}
                                    className="second-table"
                                    bordered
                                    pagination={false}
                                    dataSource={item.file_data}
                                    columns={getColumns(item.file_data, item.file_md.columns)}
                                    rowKey="Segment" />)
                    }

                </Col>
            </Row>



        </div>
    );
}

export default React.memo(FrontierTableOutput);